import type { FC, PropsWithChildren } from 'react';

import styled, { css } from 'styled-components';

import type { ISortedTable } from '../types';

const Container = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;

const SortIconWrapper = styled.div<{ $active: boolean }>(
  ({ theme: { space }, $active }) => css`
    display: flex;
    align-items: center;
    margin-left: ${space[1]}px;
    opacity: ${$active ? 1 : 0};
    transition: opacity 200ms ease-in-out;
    color: inherit;

    ${Container}:hover > & {
      opacity: 1;
    }
  `,
);

const SortUpIcon: FC = () => (
  <svg
    fill="currentColor"
    height="10"
    viewBox="0 0 10 10"
    width="10"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 2L9.33 8H0.67L5 2Z" />
  </svg>
);

const SortDownIcon: FC = () => (
  <svg
    fill="currentColor"
    height="10"
    viewBox="0 0 10 10"
    width="10"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 8L0.67 2H9.33L5 8Z" />
  </svg>
);

const ASCENDING = 'ASC';
const DESCENDING = 'DESC';

const toggleDirection = (direction?: string): 'ASC' | 'DESC' =>
  direction === ASCENDING ? DESCENDING : ASCENDING;

const SortedIndicator: FC<{ columnKey: string } & ISortedTable & PropsWithChildren> = ({
  columnKey,
  orderBy,
  orderDirection,
  children,
  onSort,
}) => {
  const isSorted = orderBy === columnKey;
  const isDescending = orderDirection === DESCENDING;
  const SortIcon = isDescending ? SortDownIcon : SortUpIcon;

  const handleSort = (): void => {
    if (onSort) {
      onSort(columnKey, isSorted ? toggleDirection(orderDirection) : DESCENDING);
    }
  };

  return (
    <Container
      onClick={handleSort}
      title={isDescending ? 'Сортировать по возрастанию' : 'Сортировать по убыванию'}
    >
      {children}
      <SortIconWrapper $active={isSorted}>
        <SortIcon />
      </SortIconWrapper>
    </Container>
  );
};

export { SortedIndicator };
